import './styles.css'

import {Header} from '@yandex-delivery/dostavka-layout'
import React from 'react'

export function HeaderRu(props): React.ReactElement {
  return <Header {...props} />
}
